import { Site } from '@/types/park/site'

export const site1: Site = {
    id: 24,
    name: 'Site 1 usine Sodebo',
    has_order: true,
}

export const site2: Site = {
    id: 2,
    name: 'Site 1 usine Campanile',
    has_order: false,
}

export const site3: Site = {
    id: 3,
    name: 'Site 1 usine Kiwi',
    has_order: true,
}
